import { Stack } from "@mui/material";
import { Menu } from "../../../styles/icons/menu";
import { useSidebarUi } from "../../layout/components/sidebar/sidebar-ui-context";
import { Logo } from "./logo";

import type { FC } from "react";

export const HeaderBarBurger: FC = () => {
  const { toggleSidebar } = useSidebarUi();

  return (
    <Stack
      data-analytics-id="sidebar-open"
      direction="row"
      spacing={0.5}
      alignItems="center"
      onClick={toggleSidebar}
      sx={{
        cursor: "pointer",
        backgroundColor: "background.default",
        borderRadius: "16px",
        py: "8px",
        px: "12px",
        borderWidth: "0px",
        color: "text.primary",
      }}
      title="Open main nav"
      component="button"
    >
      <Logo sx={{ width: "20px", height: "20px" }} />
      <Menu />
    </Stack>
  );
};
